import moment from 'moment';

export default ({scopes, teamId, error, label, success, isNewer}) => {
	return [
		...scopes.map((scope) => {
			return {
				...scope,
				teamList: [
					...scope.teamList.map((team) => {
						let t = {...team};
						if (t.teamId === +teamId) {
							if (error) {
								t.error = isNewer ? label : error;
								t.teamInstructionSentDate = moment.utc().format('YYYY-MM-DD HH:mm:ss');
							}
							if (success) {
								t.success = label;
								t.teamInstructionSentDate = moment.utc().format('YYYY-MM-DD HH:mm:ss');
							}
							if (isNewer) {
								t.isNewer = true;
								t.teamInstructionSentDate = moment.utc().format('YYYY-MM-DD HH:mm:ss');
							}
							return t;
						}

						return t;
					})
				]
			};
		})
	];
};
